import React, { useState, useEffect } from "react";
// @material-ui/core components
import { KeyboardDatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
} from "@material-ui/core";

import Loader from "../../components/Loader";
import { VEHICLE, VEHICLE_TYPE } from "../../configs/urls";

import { postApi, getApi, putApi } from "../../services/api";
import useForm from "../../formValidator/userForm";

import axios from "axios";
import { YES_NO } from "configs/constant";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: 120,
    width: "100%",
  },

  selectFullWidth: {
    margin: theme.spacing(2, 0),
    minWidth: "100%",
  },

  marginTop: {
    marginTop: "8% !important",
    width: "100%",
  },
}));

export default function VehicleOperations(props) {
  const classes = useStyles();
  const [isRequesting, setIsRequesting] = useState(false);
  const [submitButtonText, setSubmitButtonText] = useState("Add Vehicle");
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [selectedStartDate, setStartDate] = useState();
  const [selectedEndDate, setEndDate] = useState();

  const validate = (values) => {
    let errors = {};

    if (!values.vehicle_type) {
      errors.vehicle_type = "Vehicle type is required";
    }

    if (!values.registration_number) {
      errors.registration_number = "Registration number is required";
    }

    if (!values.make) {
      errors.make = "Make is required";
    }

    if (!values.year) {
      errors.year = "Year is required";
    }

    if (!values.ownership) {
      errors.ownership = "Ownership is required";
    }

    if (!values.hours) {
      errors.hours = "Hours is required";
    }

    if (!values.hours) {
      errors.hours = "Hours is required";
    }

    if (values.ownership == "rented" && !values.owner_name) {
      errors.owner_name = "Owner name is required";
    }

    if (!values.warrent_status) {
      errors.warrent_status = "Do you have warranty?";
    }

    if (
      params?.warrent_status &&
      params?.warrent_status == 1 &&
      !values.warrent_start_date
    ) {
      errors.warrent_start_date = "Select Warranty start date";
    }

    if (
      params?.warrent_status &&
      params?.warrent_status == 1 &&
      !values.warrent_end_date
    ) {
      errors.warrent_end_date = "Select Warranty end date";
    }
    if (
      values.warrent_start_date &&
      values.warrent_start_date > values.warrent_end_date
    ) {
      errors.warrent_end_date = "Select correct dates";
      errors.warrent_start_date = "Select correct dates";
    }

    return errors;
  };

  const saveVehicle = () => {
    if (params.ownership != "rented") {
      delete params.owner_name;
    }

    setIsRequesting(true);
    if (props.match && props.match.params && props.match.params.vehicle_id) {
      params.id = props.match.params.vehicle_id;
      putApi(VEHICLE, params)
        .then(
          (res) => {
            props.history.push("/admin/vehicle");
          },
          (err) => {
            console.error(err);
          }
        )
        .finally(() => {
          setIsRequesting(false);
        });
    } else {
      postApi(VEHICLE, params)
        .then(
          (res) => {
            props.history.push("/admin/vehicle");
          },
          (err) => {
            console.error(err);
          }
        )
        .finally(() => {
          setIsRequesting(false);
        });
    }
  };

  const { params, errors, handleChange, handleSubmit } = useForm(
    saveVehicle,
    validate
  );

  useEffect(() => {
    setIsRequesting(true);

    let vehicle = null;
    const vehicleType = getApi(VEHICLE_TYPE);

    if (props.match && props.match.params && props.match.params.vehicle_id) {
      vehicle = getApi(VEHICLE + "/" + props.match.params.vehicle_id);
      setSubmitButtonText("Update Vehicle");
    }

    axios
      .all([vehicleType, vehicle])
      .then((res) => {
        if (res[0] && res[0].data) {
          setVehicleTypeList(res[0].data);

          if (res[0].data[0]) params.vehicle_type = res[0].data[0].id;
          params.ownership = "rented";
        }

        if (res[1] && res[1].data) {
          const vehicleData = res[1].data;

          params.vehicle_type = vehicleData.vehicle_type;
          params.registration_number = vehicleData.registration_number;
          params.make = vehicleData.make;
          params.year = vehicleData.year;
          params.owner_name = vehicleData.owner_name;
          params.hours = vehicleData.hours;
          params.warrent_status = vehicleData.warrent_status;
          params.warrent_start_date = vehicleData.warrent_start_date;
          params.warrent_end_date = vehicleData.warrent_end_date;
          params.ownership = vehicleData.ownership.toLowerCase();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequesting(false);
      });
  }, []); //eslint-disable-line

  /**
   * @description: selection of start warranty date
   *
   * @param {Object} date
   * @returns
   */
  const handleStartDate = (date, value) => {
    setStartDate(moment(new Date(date)).format("DD/MM/YYYY"));
    params.warrent_start_date = moment(new Date(date)).format("DD/MM/YYYY");
  };

  /**
   * @description: selection of End warranty date
   *
   * @param {Object} date
   * @returns
   */
  const handleEndDate = (date, value) => {
    setEndDate(moment(new Date(date)).format("DD/MM/YYYY"));
    params.warrent_end_date = moment(new Date(date)).format("DD/MM/YYYY");
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>{submitButtonText}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="vehicle-type">Vehicle type</InputLabel>
                    <Select
                      labelId="vehicle-type"
                      id="vehicle-type-simple-select-outlined"
                      name="vehicle_type"
                      value={params?.vehicle_type || 1}
                      onChange={handleChange}
                      label="Vehicle type"
                    >
                      {vehicleTypeList.map((type, idx) => (
                        <MenuItem key={idx} value={type.id}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errors.vehicle_type && (
                    <Box color="secondary.main">{errors.vehicle_type}</Box>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="registration_number"
                    label="Registration number"
                    name="registration_number"
                    type="registration_number"
                    value={params.registration_number || ""}
                    onChange={handleChange}
                  />
                  {errors.registration_number && (
                    <Box color="secondary.main">
                      {errors.registration_number}
                    </Box>
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Ownership
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      name="ownership"
                      value={params.ownership || "owned"}
                      onChange={handleChange}
                      label="Ownership"
                    >
                      <MenuItem value="owned">Owned</MenuItem>
                      <MenuItem value="rented">Rented</MenuItem>
                    </Select>
                  </FormControl>
                  {errors.ownership && (
                    <Box color="secondary.main">{errors.ownership}</Box>
                  )}
                </GridItem>

                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="owner_name"
                    label="Owner Name"
                    name="owner_name"
                    type="owner_name"
                    value={params.owner_name || ""}
                    onChange={handleChange}
                    disabled={params.ownership !== "rented"}
                  />
                  {errors.owner_name && (
                    <Box color="secondary.main">{errors.owner_name}</Box>
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="make"
                    label="Brand Name"
                    name="make"
                    type="make"
                    value={params.make || ""}
                    onChange={handleChange}
                  />
                  {errors.make && (
                    <Box color="secondary.main">{errors.make}</Box>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="year"
                    label="Year"
                    name="year"
                    autoFocus
                    value={params.year || ""}
                    onChange={handleChange}
                  />
                  {errors.year && (
                    <Box color="secondary.main">{errors.year}</Box>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    type="number"
                    fullWidth
                    id="hours"
                    label="Hours"
                    name="hours"
                    autoFocus
                    value={params.hours || ""}
                    onChange={handleChange}
                  />
                  {errors.hours && (
                    <Box color="secondary.main">{errors.hours}</Box>
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <FormControl
                    variant="outlined"
                    className={classes.selectFullWidth}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Warranty*
                    </InputLabel>

                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      name="warrent_status"
                      value={params.warrent_status}
                      onChange={handleChange}
                      label="Contract Copy"
                    >
                      {Object.values(YES_NO).map(
                        ({ label, value, id }, idx) => {
                          return (
                            <MenuItem
                              key={idx + "-" + id + "-" + value}
                              value={id}
                            >
                              {label}
                            </MenuItem>
                          );
                        }
                      )}
                    </Select>
                  </FormControl>
                  {errors.warrent_status && (
                    <Box color="secondary.main">{errors.warrent_status}</Box>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <KeyboardDatePicker
                    autoOk
                    required
                    className={classes.marginTop}
                    variant="inline"
                    inputVariant="outlined"
                    label="Warranty Start Date"
                    format="DD/MM/YYYY"
                    value={
                      selectedStartDate || params?.warrent_start_date || ""
                    }
                    inputValue={selectedStartDate || params?.warrent_start_date}
                    name="warrent_start_date"
                    InputAdornmentProps={{ position: "start" }}
                    onChange={handleStartDate}
                    disabled={
                      (params.warrent_status && params.warrent_status == 2) ||
                      !params.warrent_status
                    }
                  />
                  {(errors?.warrent_start_date ||
                    params.warrent_status !== 1) && (
                    <Box color="secondary.main">
                      {errors.warrent_start_date}
                    </Box>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <KeyboardDatePicker
                    autoOk
                    required
                    className={classes.marginTop}
                    variant="inline"
                    inputVariant="outlined"
                    label="Warranty End Date"
                    format="DD/MM/YYYY"
                    value={selectedEndDate || params?.warrent_end_date}
                    inputValue={selectedEndDate || params?.warrent_end_date}
                    name="warrent_end_date"
                    InputAdornmentProps={{ position: "start" }}
                    onChange={handleEndDate}
                    disabled={
                      (params.warrent_status && params.warrent_status == 2) ||
                      !params.warrent_status
                    }
                  />
                  {errors?.warrent_end_date && (
                    <Box color="secondary.main">{errors.warrent_end_date}</Box>
                  )}
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                <Button onClick={handleSubmit} color="primary">
                  {submitButtonText}
                </Button>
              </Grid>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
